import FunnelSvg from '@assets/images/svg/funnel.svg';
import React from 'react';
import { View } from 'react-native';

export interface FunnelIconProps {
    size?: number;
    color?: string;
}

export function FunnelIcon({ size = 18, color = '#1A1A1A' }: FunnelIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <FunnelSvg width={size} height={size} color={color} />
        </View>
    );
}

export default FunnelIcon;
